var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"bb-form bb-form--search bb-form--sm",attrs:{"type":"search","placeholder":_vm.$t('filters.searchInTheList')},on:{"input":_vm.debounceSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }